import React, { useMemo } from "react"
import { Stack, Typography } from "@mui/material"
import { formatPriceWithCents } from "shared"
import { parsePrice } from "utils/parsers/prices"

export const SimplePriceCell = ({ price, ...rest }) => {
  const parsedPrice = useMemo(() => parsePrice(price), [price]) // parse if value is a string
  return (
    <Stack alignItems="flex-end">
      <Typography variant="body2" fontWeight={400} {...rest}>
        {formatPriceWithCents(parsedPrice)}
      </Typography>
    </Stack>
  )
}
